import { render, staticRenderFns } from "./page_chart_table.vue?vue&type=template&id=8f800824&scoped=true"
import script from "./page_chart_table.vue?vue&type=script&lang=js"
export * from "./page_chart_table.vue?vue&type=script&lang=js"
import style0 from "./page_chart_table.vue?vue&type=style&index=0&id=8f800824&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f800824",
  null
  
)

export default component.exports